import React from "react";
import { useI18n } from "@/i18n/I18nProvider";
import { Lang, langConfig } from "@/i18n/translations";
import { Globe } from "lucide-react";

const LanguageSwitcher = ({ iconOnly }: { iconOnly?: boolean }) => {
  const { lang, setLang } = useI18n();

  const langs: Lang[] = ["fr", "ar", "zgh"];

  return (
    <div className="flex items-center gap-1 bg-muted rounded-full p-1 h-8 md:h-9">
      {langs.map((l) => (
        <button
          key={l}
          onClick={() => setLang(l)}
          translate="no"
          className={`notranslate px-3 py-1 rounded-full text-xs md:text-sm font-body font-bold md:font-medium transition-all h-full flex items-center ${
            lang === l
              ? "bg-primary text-primary-foreground shadow-sm"
              : "text-muted-foreground hover:text-foreground"
          }`}
        >
          {langConfig[l].label}
        </button>
      ))}
    </div>
  );
};

export default LanguageSwitcher;
